<script>import {
  createFieldContext
} from "../../components/form/helper/field.js";
import { createEventDispatcher, getContext } from "svelte";
export let name = void 0;
export let value;
export let error = void 0;
export let disabled = false;
export let empty = value == void 0;
export let detail = void 0;
const dispatch = createEventDispatcher();
const contextKey = createFieldContext(
  name,
  value,
  error,
  disabled,
  empty,
  detail
);
const ctx = getContext(contextKey);
const ctxValue = ctx.value;
const ctxEmpty = ctx.empty;
$: {
  ctx.value.set(value);
  ctx.error.set(error);
  ctx.disabled.set(disabled);
  ctx.empty.set(value == void 0);
}
$: {
  const oldValue = value;
  value = $ctxValue;
  if (oldValue !== value) {
    dispatch("changed", { name, value });
  }
}
$:
  empty = $ctxEmpty;
</script>

<slot {contextKey} />
